import matrices from "./content/matrices";
import nomenclature from "./content/nomenclature";
import syncronization from "./content/syncronization";
import users from "./content/users";
import settings from "./content/settings";

const router = [...matrices, ...nomenclature, syncronization, users, ...settings];

export default router;
